<template>
    <v-form-element :id="id" :label="label" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <div class="relative">
            <select
                :id="id"
                :class="className + ' apparance-none'" 
                v-model="model"
                :multiple="multiple"
            >
                <option :value="null" v-if="allowNull">{{ placeholder }}</option>
                <option v-for="option in options" :value="value(option)" :key="value(option)">
                    {{ key(option) }}
                </option>
            </select>
            <i class="fas fa-angle-down text-gray-500 group-hover:text-white text-sm absolute center-y right-0 pr-4"></i>
        </div>
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            optionKey: {
                type: String,
                default: 'title'
            },
            optionValue: {
                type: String,
                default: 'id'
            },
            allowNull: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        mixins: [mixin],
        methods: {
            value(option)
            {
                if ( option[this.optionValue] ) {
                    return option[this.optionValue];
                }
                return option;
            },
            key(option)
            {
                if ( option[this.optionKey] ) {
                    return option[this.optionKey];
                }
                return option;
            }
        },
        created() {
            if ( ! this.allowNull && this.options[0] && ! this.form[this.inputName] ) {
                this.model = this.options[0][this.optionValue];
            }
        }
    }
</script>
